import { IonPage } from '@ionic/react';
import React, { useCallback, useState } from 'react';
import './Index.scss';
import DashboardPage from './dashboard/DashboardPage';

const Index: React.FC = () => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  const handleScroll = useCallback((event: CustomEvent) => {
    setScrollPosition(event.detail.currentY);
  }, []);

  return (
    <IonPage id="home" className="console-page">
      {/*<IonContent fullscreen scrollEvents onIonScroll={handleScroll}>*/}
      {/*  <IonGrid>*/}
      {/*    <IonRow className="feed-wrapper">*/}
      {/*      <IonCol size="12">*/}

      <DashboardPage />

      {/*      </IonCol>*/}
      {/*    </IonRow>*/}
      {/*  </IonGrid>*/}
      {/*</IonContent>*/}
    </IonPage>
  );
};

export default Index;
